import api from './api'

/**
 * Serviços para gerenciar ordenação de workspaces
 */
export const workspaceOrdenacaoService = {
  
  /**
   * Salva a ordenação personalizada de workspaces para um usuário
   * @param {number} usuarioId - ID do usuário
   * @param {Array<number>} workspaceIds - Array com IDs dos workspaces na ordem desejada
   * @returns {Promise<Object>} Resposta da API
   */
  async salvarOrdenacao(usuarioId, workspaceIds) {
    try {
      console.log('📋 Salvando ordenação:', { usuarioId, workspaceIds })
      
      const response = await api.post(`/workspace-ordenacao/${usuarioId}`, {
        workspaceIds
      })
      
      console.log('✅ Ordenação salva com sucesso:', response.data)
      return response.data
    } catch (error) {
      console.error('❌ Erro ao salvar ordenação:', error)
      throw error
    }
  },
  
  /**
   * Recupera a ordenação personalizada de workspaces para um usuário
   * @param {number} usuarioId - ID do usuário
   * @returns {Promise<Array>} Lista de workspaces ordenados
   */
  async getOrdenacao(usuarioId) {
    try {
      console.log('📋 Buscando ordenação para usuário:', usuarioId)
      
      const response = await api.get(`/workspace-ordenacao/${usuarioId}`)
      
      console.log('✅ Ordenação recuperada:', response.data)
      return response.data.ordenacao || []
    } catch (error) {
      console.error('❌ Erro ao buscar ordenação:', error)
      throw error
    }
  },
  
  /**
   * Reordena um workspace específico (drag & drop)
   * @param {number} usuarioId - ID do usuário
   * @param {number} workspaceId - ID do workspace sendo movido
   * @param {number} novaPosicao - Nova posição (1-based)
   * @returns {Promise<Object>} Resposta da API
   */
  async reordenarWorkspace(usuarioId, workspaceId, novaPosicao) {
    try {
      console.log('🔄 Reordenando workspace:', { usuarioId, workspaceId, novaPosicao })
      
      const response = await api.put(`/workspace-ordenacao/${usuarioId}/reordenar`, null, {
        params: {
          workspaceId,
          novaPosicao
        }
      })
      
      console.log('✅ Workspace reordenado:', response.data)
      return response.data
    } catch (error) {
      console.error('❌ Erro ao reordenar workspace:', error)
      throw error
    }
  },
  
  /**
   * Inicializa ordenação padrão para um usuário
   * @param {number} usuarioId - ID do usuário
   * @returns {Promise<Object>} Resposta da API
   */
  async inicializarOrdenacaoPadrao(usuarioId) {
    try {
      console.log('🚀 Inicializando ordenação padrão para usuário:', usuarioId)
      
      const response = await api.post(`/workspace-ordenacao/${usuarioId}/inicializar`)
      
      console.log('✅ Ordenação padrão inicializada:', response.data)
      return response.data
    } catch (error) {
      console.error('❌ Erro ao inicializar ordenação padrão:', error)
      throw error
    }
  },
  
  /**
   * Verifica se usuário tem ordenação personalizada
   * @param {number} usuarioId - ID do usuário
   * @returns {Promise<boolean>} True se tem ordenação personalizada
   */
  async temOrdenacaoPersonalizada(usuarioId) {
    try {
      console.log('🔍 Verificando se usuário tem ordenação personalizada:', usuarioId)
      
      const response = await api.get(`/workspace-ordenacao/${usuarioId}/tem-ordenacao`)
      
      console.log('✅ Status da ordenação:', response.data)
      return response.data.temOrdenacao || false
    } catch (error) {
      console.error('❌ Erro ao verificar ordenação personalizada:', error)
      return false
    }
  }
}
